//keyArray里定义所有会用到的权限类型，treeData里的name值必须从这里选，否则匹配不到
export default {
    keyArray:[
        {
            key: "Query",
            desc: "查询权限，比如查询列表，查询详情",
        },
        {
            key: "New",
            desc: "新增权限，比如列表右上角的新增按钮",
        },
        {
            key: "Edit",
            desc: "编辑权限，比如列表操作栏的编辑，禁用等",
        },
        {
            key: "Delete",
            desc: "删除权限，比如列表操作栏的删除",
        },
        {
            key: "Developer",
            desc: "开发者权限，（属于自定义）",
        },
        {
            key: "Special",
            desc: "特殊权限，（属于自定义）",
        },
    ],
    treeData:[
        {
            title: '通用权限',
            key: 'Others',
            hide: true, //这个权限不需要选择，设置为隐藏(比如查询个人信息，修改密码等)
            children: [
                {
                    title: '查询',
                    name: 'Query',
                    permit: true,
                    key: 'OthersQuery',
                    url: '/admin/admin/getMyinfo,/admin/admin/modfiyPasswd,/admin/admin/logoutAdmin,/admin/space/getSpaceList,/platform/admin/device/getDeviceRomIdList,/admin/company/select,/admin/common/getCountryList,/admin/deviceHeartbeat/getHeartBeatRomIds,/admin/globalConfig/getAllGlobalConfigs,/admin/space/getAllSpaces,/admin/common/getProvinceList,/admin/common/getCityList,/admin/common/getCountry,/platform/admin/terminal/classificationSearch,/platform/admin/pricePackage/targetTag,/platform/admin/personageAdmin/getPersonagePositionSimplifiedList,/platform/admin/personageAdmin/getPersonageCapSimplifiedList'
                },
                {
                    title: '编辑',
                    name: 'Edit',
                    permit: true,
                    key: 'OthersEdit',
                    url: '/admin/common/getUploadToken,/common/upload'
                },
            ]
        },
        {
            title: '设备统计',
            key: 'DeviceStatics',
            children: [
                {
                    title: '设备统计相关权限',
                    name: 'Query',
                    permit: true,
                    key: 'DeviceStaticsQuery',
                    url: '/platform/admin/device/getDeviceList,/admin/deviceHeartbeat/getDeviceTotal,/admin/deviceHeartbeat/getDeviceDayLoss,/admin/deviceHeartbeat/getLatestThirtyAddDevice,/admin/deviceHeartbeat/getOfflineThirtyDevice,/admin/deviceHeartbeat/getOnOfflineDeviceRate,/admin/deviceHeartbeat/getDeviceLocation,/admin/deviceHeartbeat/getHeartBeatRomIds,/admin/deviceHeartbeat/getDeviceMonthStandard,/admin/deviceHeartbeat/getOnOfflineAllDeviceRate,/admin/deviceHeartbeat/getLatestAllAddDevice,/admin/deviceHeartbeat/getDeviceDayHeartbeat,/admin/deviceHeartbeat/getDeviceDayOnline,/admin/deviceHeartbeat/getDevice,/admin/deviceHeartbeat/getHeartbeatDeviceList,/admin/deviceHeartbeat/exportHeartbeatDeviceList,/admin/deviceHeartbeat/getCountryDevice,/admin/deviceHeartbeat/getDeviceFreeSize,/platform/admin/device/statistics/getSpaceList,/platform/admin/device/statistics/getDeviceList,/platform/admin/device/statistics/countryStatistics,/platform/admin/device/statistics/spaceStatistics,/platform/admin/device/statistics/ipStatistics,/platform/admin/device/statistics/mobileStatistics,/admin/device/getDeviceCenter,/admin/device/getDeviceScript,/admin/device/getDeviceRemote,/admin/device/getDeviceTop20,/admin/device/getDeviceRom,/admin/device/getDeviceFreeSize,/admin/device/getDeviceByCondList,/admin/device/exportDeviceByCond'
                },
            ]
        },
        {
            title: '设备管理',
            key: 'DeviceManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'DeviceManageQuery',
                    url: '/platform/admin/device/getDeviceList,/admin/device/addDeviceList,/platform/admin/device/getDeviceIds,/admin/conf/getShardConfList,/admin/conf/getDeviceDynamicAssignConf,/admin/shardDelDevice/getDeviceList,/admin/conf/getBoxShard'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'DeviceManageNew',
                    url: '/admin/shardDelDevice/addDevice'
                },
                {
                    title: '操作',
                    name: 'Edit',
                    permit: true,
                    key: 'DeviceManageEdit',
                    url: '/platform/admin/device/assignDeviceToCompany,/admin/conf/setDeviceDynamicAssignConf,/admin/conf/editShardConf,/admin/conf/addShardConf'
                },
                {
                    title: '删除',
                    name: 'Delete',
                    permit: true,
                    key: 'DeviceManageDelete',
                    url: '/admin/shardDelDevice/delDevice'
                }
            ]
        },
        {
            title: '安装包管理',
            key: 'PackageManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'PackageManageQuery',
                    url: '/admin/app/getAppList,/admin/app/getApps,/admin/appVersion/getAppVersionList,/admin/appIpfs/getDeviceList'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'PackageManageNew',
                    url: '/admin/app/addApp,/admin/appVersion/addAppVersion,/admin/appIpfs/addDevice,/platform/admin/user/codeUpdate'
                },
                {
                    title: '编辑',
                    name: 'Edit',
                    permit: true,
                    key: 'PackageManageEdit',
                    url: '/admin/app/editApp,/admin/appVersion/editAppVersion,/admin/appVersion/setAppVersionStatus'
                },
                {
                    title: '删除',
                    name: 'Delete',
                    permit: true,
                    key: 'PackageManageDelete',
                    url: '/admin/app/delApp,/admin/appVersion/delAppVersion,/admin/appIpfs/delDevice'
                },
            ]
        },
        {
            title: '公司管理',
            key: 'CompanyManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'CompanyManageQuery',
                    url: '/admin/company/index,/admin/company/select'
                },
                {
                    title: '创建公司',
                    name: 'New',
                    permit: true,
                    key: 'CompanyManageNew',
                    url: '/admin/company/create'
                },
                {
                    title: '编辑公司',
                    name: 'Edit',
                    permit: true,
                    key: 'CompanyManageEdit',
                    url: '/admin/company/update'
                },
                {
                    title: '删除公司',
                    name: 'Delete',
                    permit: true,
                    key: 'CompanyManageDelete',
                    url: '/admin/company/delete'
                }
            ]
        },
        {
            title: '企业管理',
            key: 'CorporationManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'CorporationManageQuery',
                    url: '/platform/admin/personageAdmin/company/list,/platform/admin/personageAdmin/company/memberList,/platform/admin/personageAdmin/company/deviceList,/platform/admin/personageAdmin/company/capPositionList'
                },
                {
                    title: '编辑企业',
                    name: 'Edit',
                    permit: true,
                    key: 'CorporationManageEdit',
                    url: '/platform/admin/personageAdmin/company/enable'
                },
            ]
        },
        {
            title: '用户管理',
            key: 'UserManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'UserManageQuery',
                    url: '/platform/admin/user/index'
                },
                {
                    title: '创建用户',
                    name: 'New',
                    permit: true,
                    key: 'UserManageNew',
                    url: '/platform/admin/user/create'
                },
                {
                    title: '编辑用户',
                    name: 'Edit',
                    permit: true,
                    key: 'UserManageEdit',
                    url: '/platform/admin/user/update'
                },
                {
                    title: '删除用户',
                    name: 'Delete',
                    permit: true,
                    key: 'UserManageDelete',
                    url: '/platform/admin/user/delete'
                }
            ]
        },
        {
            title: '日志管理',
            key: 'LogManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'LogManageQuery',
                    url: '/admin/syslog/getSyslogList'
                },
                {
                    title: '清除',
                    name: 'Delete',
                    permit: true,
                    key: 'LogManageDelete',
                    url: '/admin/syslog/delSyslogs'
                },
            ]
        },
        {
            title: '模型管理',
            key: 'ModelManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'ModelManageQuery',
                    url: '/platform/admin/aiModel/aiModeGroupList,/platform/admin/aiModel/modelKeysList,/platform/admin/aiModel/getKeyList'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'ModelManageNew',
                    url: '/platform/admin/aiModel/addAiModelGroup,/platform/admin/aiModel/addKey,/platform/admin/aiModel/addKeyEntity'
                },
                {
                    title: '编辑用户',
                    name: 'Edit',
                    permit: true,
                    key: 'ModelManageEdit',
                    url: '/platform/admin/aiModel/editAiModelGroup,/platform/admin/aiModel/enableStatus,/platform/admin/aiModel/editKey,/platform/admin/aiModel/editKeyEntity'
                },
                {
                    title: '删除',
                    name: 'Delete',
                    permit: true,
                    key: 'ModelManageDelete',
                    url: '/platform/admin/aiModel/deleteAiModelGroup,/platform/admin/aiModel/deleteKey,/platform/admin/aiModel/delKeyEntity'
                },
            ]
        },
        {
            title: '分析配置管理',
            key: 'DashboardThemeManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'DashboardThemeManageQuery',
                    url: '/platform/admin/chartTheme/getChartThemeList,/platform/admin/chartTheme/getChartTheme,/platform/admin/dashBoardModel/updateDashboardModelImg,/platform/admin/dashBoardModel/getDashboardModelDetail,/platform/admin/dashBoardModel/getDashboardModelHistoryList,/platform/admin/dashBoardModel/getDashboardHistory,/platform/admin/dashBoardModel/getDashboardModelList,/platform/admin/module/getModuleCategoryAndModuleList,/platform/admin/module/executeDbQuery,/platform/admin/module/getCustomModuleDetail,/platform/admin/module/getCustomModuleList,/platform/admin/module/getBackStageCategory,/platform/admin/chartTheme/getChartThemeListAll'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'DashboardThemeManageNew',
                    url: '/platform/admin/chartTheme/addChartTheme,/platform/admin/dashBoardModel/addDashBoardModel,/platform/admin/dashBoardModel/copyDashboard,/platform/admin/module/editOrAddCustomModule,/platform/admin/module/editOrAddModuleCategory'
                },
                {
                    title: '编辑',
                    name: 'Edit',
                    permit: true,
                    key: 'DashboardThemeManageEdit',
                    url: '/platform/admin/chartTheme/editChartTheme,/platform/admin/chartTheme/setChartThemeStatus,/platform/admin/chartTheme/setChartThemeSort,/platform/admin/dashBoardModel/setDashboardModelSort,/platform/admin/dashBoardModel/editDashboardModel,/platform/admin/dashBoardModel/updateDashboardModel,/platform/admin/module/editOrAddCustomModule,/platform/admin/module/editOrAddModuleCategory'
                },
                {
                    title: '清除',
                    name: 'Delete',
                    permit: true,
                    key: 'DashboardThemeManageDelete',
                    url: '/platform/admin/chartTheme/delChartTheme,/platform/admin/dashBoardModel/delDashboardModel,/platform/admin/module/delCustomModule,/platform/admin/module/delModuleCategory'
                },
            ]
        },
        {
            title: '咨询工单管理',
            key: 'ConsultManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'ConsultManageQuery',
                    url: '/platform/admin/personageAdmin/getWorkOrderList'
                },
                {
                    title: '编辑',
                    name: 'Edit',
                    permit: true,
                    key: 'ConsultManageEdit',
                    url: '/platform/admin/personageAdmin/updateWorkOrderStatus'
                },
            ]
        },
        {
            title: '官网内容配置',
            key: 'WebsiteDynamicManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'WebsiteDynamicManageQuery',
                    url: '/platform/admin/personageAdmin/getConfCommentList,/platform/admin/personageAdmin/getConfBuyStatsList'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'WebsiteDynamicManageNew',
                    url: '/platform/admin/personageAdmin/addConfComment,/platform/admin/personageAdmin/addConfBuyStats'
                },
                {
                    title: '编辑',
                    name: 'Edit',
                    permit: true,
                    key: 'WebsiteDynamicManageEdit',
                    url: '/platform/admin/personageAdmin/updateConfComment,/platform/admin/personageAdmin/updateConfCommentStatus,/platform/admin/personageAdmin/updateConfBuyStats,/platform/admin/personageAdmin/updateConfBuyStatsStatus'
                },
                {
                    title: '删除',
                    name: 'Delete',
                    permit: true,
                    key: 'WebsiteDynamicManageDelete',
                    url: '/platform/admin/personageAdmin/delConfComment,/platform/admin/personageAdmin/delConfBuyStats'
                },
            ]
        },
        {
            title: '商品推荐管理',
            key: 'GoodsManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'GoodsManageQuery',
                    url: '/platform/admin/personageAdmin/getPersonageCapList,/platform/admin/personageAdmin/getPersonagePositionList'
                },
                {
                    title: '编辑',
                    name: 'Edit',
                    permit: true,
                    key: 'GoodsManageEdit',
                    url: '/platform/admin/personageAdmin/setPersonageCapSystemTag,/platform/admin/personageAdmin/setPersonagePositionSystemTag'
                },
            ]
        },
        {
            title: '商业运营管理',
            key: 'BusinessOperation',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'BusinessOperationQuery',
                    url: '/platform/admin/vip/vipList,/platform/admin/vip/devVipList,/platform/admin/pricePackage/getList,/platform/admin/companySeat/getSeatPackageList,/platform/admin/companySeat/getSeatPackageDetail'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'BusinessOperationNew',
                    url: '/platform/admin/pricePackage/add,/platform/admin/companySeat/saveSeatPackage'
                },
                {
                    title: '编辑',
                    name: 'Edit',
                    permit: true,
                    key: 'BusinessOperationEdit',
                    url: '/platform/admin/vip/editVip,/platform/admin/vip/editDevVip,/platform/admin/pricePackage/edit,/platform/admin/pricePackage/disable,/platform/admin/companySeat/saveSeatPackage,/platform/admin/companySeat/setSeatPackageStatus'
                },
                {
                    title: '删除',
                    name: 'Delete',
                    permit: true,
                    key: 'BusinessOperationDelete',
                    url: '/platform/admin/pricePackage/del,/platform/admin/companySeat/deleteSeatPackage'
                },
            ]
        },
        {
            title: '订单管理',
            key: 'OrderManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'OrderManageQuery',
                    url: '/platform/admin/order/statistics,/platform/admin/order/getList'
                },
            ]
        },
        {
            title: '平台协议管理',
            key: 'PlatformProtocolManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'PlatformProtocolManageQuery',
                    url: '/platform/admin/agreement/getAgreementGroupList,/platform/admin/agreement/getAgreementList'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'PlatformProtocolManageNew',
                    url: '/platform/admin/agreement/createAgreement,/platform/admin/agreement/createAgreementGroup'
                },
                {
                    title: '编辑',
                    name: 'Edit',
                    permit: true,
                    key: 'PlatformProtocolManageEdit',
                    url: '/platform/admin/agreement/editAgreementGroup,/platform/admin/agreement/editAgreement,/platform/admin/agreement/editAgreementSort,/platform/admin/agreement/disable'
                },
                {
                    title: '删除',
                    name: 'Delete',
                    permit: true,
                    key: 'PlatformProtocolManageDelete',
                    url: '/platform/admin/agreement/delAgreementGroup,/platform/admin/agreement/delAgreement'
                },
            ]
        },
        {
            title: '审核管理',
            key: 'AuditManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'AuditManageQuery',
                    url: '/platform/admin/personageAdmin/getMagicPowerWithdrawList,/platform/admin/review/getReviewList'
                },
                {
                    title: '操作',
                    name: 'Edit',
                    permit: true,
                    key: 'AuditManageEdit',
                    url: '/platform/admin/personageAdmin/MagicPowerWithdraw,/platform/admin/review/ignoreReview,/platform/admin/review/offReview,/platform/admin/review/delComment'
                },
            ]
        },
        {
            title: '内置查询配置',
            key: 'BuiltInQueryManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'BuiltInQueryManageQuery',
                    url: '/admin/chartBuiltInQuery/getBuiltInQueryList,/admin/chartBuiltInQuery/getBuiltInQuery'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'BuiltInQueryManageNew',
                    url: '/admin/chartBuiltInQuery/addBuiltInQuery'
                },
                {
                    title: '编辑',
                    name: 'Edit',
                    permit: true,
                    key: 'BuiltInQueryManageEdit',
                    url: '/admin/chartBuiltInQuery/editBuiltInQuery,/admin/chartBuiltInQuery/setBuiltInQuerySort'
                },
                {
                    title: '清除',
                    name: 'Delete',
                    permit: true,
                    key: 'BuiltInQueryManageDelete',
                    url: '/admin/chartBuiltInQuery/delBuiltInQuery'
                },
            ]
        },
        {
            title: '系统全局配置',
            key: 'SystemManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'SystemManageQuery',
                    url: '/admin/globalConfig/getAllGlobalConfigs,/admin/plan/getPlanDistribLimit'
                },
                {
                    title: '修改',
                    name: 'Edit',
                    permit: true,
                    key: 'SystemManageEdit',
                    url: '/admin/globalConfig/setGlobalConfigs,/admin/plan/setPlanDistribLimit'
                },
            ]
        },
        {
            title: '后台账号管理',
            key: 'AccountManage2',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'AccountManage2Query',
                    url: '/admin/admin/getAdminList,/admin/admin/getAdminDetail'
                },
                {
                    title: '创建后台管理账号',
                    name: 'New',
                    permit: true,
                    key: 'AccountManage2New',
                    url: '/admin/admin/addAdmin'
                },
                {
                    title: '编辑后台账号',
                    key: 'AccountManage2Edit',
                    permit: true,
                    name: 'Edit',
                    url: '/admin/admin/editAdmin,/admin/admin/enableAdmin,/admin/admin/authRomIds,/admin/admin/setOtherAccount,/admin/admin/removeOtherAccount'
                },
                {
                    title: '删除后台账号',
                    name: 'Delete',
                    permit: true,
                    key: 'AccountManage2Delete',
                    url: '/admin/admin/delAdmin'
                }
            ]
        },
        {
            title: 'ESIM管理',
            key: 'ESIMManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'ESIMManageQuery',
                    url: '/platform/admin/getMessageList,/platform/admin/getESIMList,/platform/admin/getPlatformList,/platform/admin/deviceStatistics,/platform/admin/esimBlackList,/platform/admin/exclusive/getESIMList,/platform/admin/exclusive/deviceStatistics,/platform/admin/getDistinctClassify'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'ESIMManageNew',
                    url: '/platform/admin/insert,/platform/admin/esimBlackAdd,/platform/admin/exclusive/insert'
                },
                {
                    title: '编辑',
                    key: 'ESIMManageEdit',
                    permit: true,
                    name: 'Edit',
                    url: '/platform/admin/update,/platform/admin/sendTestMessage,/platform/admin/preBind,/platform/admin/exclusive/update,/platform/admin/exclusive/preBind'
                },
                {
                    title: '回收',
                    name: 'Delete',
                    permit: true,
                    key: 'ESIMManageDelete',
                    url: '/platform/admin/recycleEsim,/platform/admin/esimBlackDel,/platform/admin/exclusive/recycleEsim'
                }
            ]
        },
        {
            title: '终端管理',
            key: 'RomManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'RomManageQuery',
                    url: '/platform/admin/terminal/getClassificationList,/platform/admin/terminal/getRuleList,/platform/admin/terminal/ruleRomList,/platform/admin/terminal/renewal'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'RomManageNew',
                    url: '/platform/admin/terminal/insertClassification,/platform/admin/terminal/insertRule'
                },
                {
                    title: '编辑',
                    key: 'RomManageEdit',
                    permit: true,
                    name: 'Edit',
                    url: '/platform/admin/terminal/updateClassification,/platform/admin/terminal/updateRule'
                },
                {
                    title: '删除',
                    name: 'Delete',
                    permit: true,
                    key: 'RomManageDelete',
                    url: '/platform/admin/terminal/deleteClassification,/platform/admin/terminal/deleteRule'
                }
            ]
        },
        {
            title: '回收站',
            key: 'RecycleManage',
            children: [
                {
                    title: '查看',
                    name: 'Query',
                    permit: true,
                    key: 'RecycleManageQuery',
                    url: '/platform/admin/getRecycleEsimList'
                },
                {
                    title: '新增',
                    name: 'New',
                    permit: true,
                    key: 'RecycleManageNew',
                    url: ''
                },
                {
                    title: '编辑、还原',
                    key: 'RecycleManageEdit',
                    permit: true,
                    name: 'Edit',
                    url: '/platform/admin/restoreESim,/platform/admin/exclusive/restoreESim'
                },
                {
                    title: '删除',
                    name: 'Delete',
                    permit: true,
                    key: 'RecycleManageDelete',
                    url: ''
                }
            ]
        },
        {
            title: '关联其它后台',
            key: 'OtherSysManage',
            children: [
                {
                    title: '访问',
                    name: 'Query',
                    permit: true,
                    key: 'OtherSysManageQuery',
                    url: '/admin/admin/getOtherAccount,/platform/admin/getOssStsToken,/platform/admin/node/uploadDoc,/platform/admin/review/getReviewList,/platform/admin/review/ignoreReview,/platform/admin/review/delComment,/platform/admin/review/offReview,/platform/admin/review/checkText,/platform/admin/review/asyncCheckImageOrVideo'
                },
            ]
        },
    ]
};
